import React, { memo } from 'react'
import { Box } from '@mui/material'
import { NonInteractiveTooltip } from '../../custom'
import { formatGotoDate } from '../../../util/general'
import ScreenerChartTooltip from '../screenerChartTooltip/screenerChartTooltip'

export type GotoDateTooltipProps = {
    gotoDate: number
    x: number
    top: number
}

export type RootChartTooltipProps = {
    title: string
    x: number
    top: number
}

export type ChartMountOverlaysProps = {
    gotoDateTooltip?: GotoDateTooltipProps | null
    rootTooltip?: RootChartTooltipProps | null
    screenerChart?: boolean
    screenerTooltipVisible: boolean
    screenerTooltipPosition: { x: number; y: number }
    screenerSecurity?: {
        symbol: string
        logoUrl?: string
        code: string
    }
    screenerTooltipData: {
        price?: number
        volume?: number
        isProfit?: boolean
        time?: number
    } | null
}

const ChartMountOverlays = ({
    gotoDateTooltip,
    rootTooltip,
    screenerChart,
    screenerTooltipVisible,
    screenerTooltipPosition,
    screenerSecurity,
    screenerTooltipData,
}: ChartMountOverlaysProps) => (
    <>
        {gotoDateTooltip ? (
            <NonInteractiveTooltip
                title={formatGotoDate(gotoDateTooltip.gotoDate)}
                key="payoff-striker-tooltip"
                open
                placement="top"
                arrow
                slotProps={{
                    popper: {
                        sx: { zIndex: 1 },
                    },
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        left: gotoDateTooltip.x,
                        top: gotoDateTooltip.top,
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                    }}
                />
            </NonInteractiveTooltip>
        ) : null}
        {rootTooltip ? (
            <NonInteractiveTooltip
                title={rootTooltip.title}
                key="chart-root-tooltip"
                open
                placement="top"
                arrow
                slotProps={{
                    popper: {
                        sx: { zIndex: 99 },
                    },
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        left: rootTooltip.x,
                        top: rootTooltip.top,
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                    }}
                />
            </NonInteractiveTooltip>
        ) : null}
        {screenerChart && screenerTooltipVisible && screenerSecurity ? (
            <ScreenerChartTooltip
                visible={screenerTooltipVisible}
                x={screenerTooltipPosition.x}
                y={screenerTooltipPosition.y}
                security={screenerSecurity}
                price={screenerTooltipData?.price}
                volume={screenerTooltipData?.volume}
                isProfit={screenerTooltipData?.isProfit}
                time={screenerTooltipData?.time}
            />
        ) : null}
    </>
)

export default memo(ChartMountOverlays)
